export default __webpack_public_path__ + "static/media/APEIN.d569384f.png";